import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

export const getSrc = () => {
  try {
    const p = new URLSearchParams(window.location.search).get("src");
    if (p) localStorage.setItem("chela_src", p.slice(0, 40));
    return (p || localStorage.getItem("chela_src") || "").slice(0, 40);
  } catch (e) { return ""; }
};

export const track = (event, meta = {}) => {
  try {
    const src = getSrc();
    api.post("/analytics/event", { event, meta: src ? { ...meta, src, path: window.location.pathname } : { ...meta, path: window.location.pathname } }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
};

export const WHATSAPP_NUMBER = "919540088845";

let razorpayPromise = null;
export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (razorpayPromise) return razorpayPromise;
  razorpayPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return razorpayPromise;
}

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
